export default function ParticipantsStatus({item, style}){
  return <div style={{
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    position: "relative",
    minHeight: 30,
    ...style
  }}>
    <div style={{
      height: 4,
      width: "85%",
      backgroundColor: "var(--lightgray)",
      borderRadius: 1,
      position: "absolute",
      top: 21,
    }}/>
    <div style={{
      height: 6,
      borderRadius: 2,
      width: (item.participants.length / item.participantsMax) * 85 + "%",
      backgroundColor: item.participants.length !== item.participantsMax? "var(--green)": "var(--red)",
      position: "absolute",
      top: 20,
    }}/>
    <div style={{
      color: "var(--white)",
      position: "absolute",
      top:0,
      left:0,
      display: "flex",
      flexDirection: "row"
    }}>
      <div style={{color: item.participants.length !== item.participantsMax? "var(--green)": "var(--red)"}}>{item.participants.length}</div>
      /{item.participantsMax}
    </div>
  </div>;
}